import { useMemo } from "react";
import { useCategoryContext, useCategoryMetaContext } from "../Context";

import _ from "lodash";
export const useCategoryBreadcrumb = () => {
    const { tIdToCategory } = useCategoryMetaContext();
    const { category } = useCategoryContext();
    const breadcrumb = useMemo(() => {
        const categoryParent = tIdToCategory?.[category?.parentId];
        const categorySuperParent = tIdToCategory?.[categoryParent?.parentId];
        return _.join(
            [categorySuperParent, categoryParent, category].filter(d => d != null).map(d => d.displayName),
            " -> "
        );
    }, [tIdToCategory, category]);

    return { breadcrumb, category, tIdToCategory };
};
